import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * Generated class for the NyhaToolComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "nyha-tool",
  templateUrl: "nyha-tool.html",
})
export class NyhaToolComponent {
  @Input() readonly: boolean = false;
  @Output() onValueUpdate: EventEmitter<any> = new EventEmitter();

  value;

  rows = [
    {
      grade: "nyhaClass1",
      description: "nyhaClass1desc",
      met: ">7",
    },
    {
      grade: "nyhaClass2",
      description: "nyhaClass2desc",
      met: "5",
    },
    {
      grade: "nyhaClass3",
      description: "nyhaClass3desc",
      met: "2-3",
    },
    {
      grade: "nyhaClass4",
      description: "nyhaClass4desc",
      met: "1.6",
    },
  ];

  constructor() {}

  @Input() set existingData(data: object) {
    if (data !== undefined && data != null) {
      this.value = data["value"];
    }
  }

  valueChanged(value: number) {
    if (!this.readonly) {
      this.value = value;
      this.onValueUpdate.emit({
        value: this.value,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/nyha-tool/nyha-tool.ts